module.exports = __webpack_public_path__ + "static/img/QLD-27.d51311c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-27.jpg
// module id = U5XT
// module chunks = 0